export enum AlertTypes {
  HEARTBEAT = 1
}
